import { ButtonSize, ButtonVariants } from '@anm/components/buttons/Button';
import Dialog from '@anm/components/modals/Dialog';
import Confirm from '@anm/components/notification/Confirm';
import noop from '@anm/helpers/noop';
import { FC } from 'react';

export type EditEmbeddedAlertProps = {
  editorUrl: string;
  onClose(): void;
  onCancel(): void;
};

const editEmbedAlertText =
  "You are about to edit an embedded video. This will update the video wherever it's embedded. <br/>Are you sure?";

const EditEmbeddedAlert: FC<EditEmbeddedAlertProps> = ({
  editorUrl,
  onCancel,
  onClose = noop
}) => (
  <Dialog onModalClose={onClose}>
    <Confirm
      title="This video is embedded"
      titleSize="medium"
      buttonLeft={{
        isPending: false,
        href: editorUrl,
        text: 'Yes, edit this video',
        size: 'upper-medium' as ButtonSize,
        variant: 'blue-heavy-border' as ButtonVariants
      }}
      buttonRight={{
        isPending: false,
        text: 'Duplicate and edit a copy',
        size: 'upper-medium' as ButtonSize,
        variant: 'light-blue' as ButtonVariants
      }}
      onLeftButtonClick={noop}
      onRightButtonClick={() => {
        onCancel();
        onClose();
      }}
    >
      {editEmbedAlertText}
    </Confirm>
  </Dialog>
);

export default EditEmbeddedAlert;
